

import { useState, useEffect } from "react"
import "../css/Lobbies.css";

import { useNavigate } from "react-router";
export default function DotsBoxesLobby() {

    const navigate = useNavigate()
    const [games, setGames] = useState([]);

    useEffect(() => {
        async function loadGameList() {
            const response = await fetch('https://anagrams.ca/api/connect/lobbies');
            const data = await response.json();
            setGames(data)
        }
        loadGameList()
        const interval = setInterval(loadGameList, 12000)
        return () => clearInterval(interval);

    }, [])

    async function joinGameClick(gameId, user) {

        console.log('Joining Game')
        const username = user || window.prompt('Enter your username!');

        if(!username){
            return
        }

        const response = await fetch(`https://anagrams.ca/api/connect/${gameId}/join?username=${username}`, {
            method: "POST"
        });

        const data = await response.json();

        if(data['error']){
            console.log('Error')
            console.log(data)
            return alert(data['error']);
        }
        
        console.log(`Recieved data for joining..`)
        console.log(data)

        navigate(`/connectfour`, {
            state: {
                gameId: data['game_id'],
                username: username
            }
        });
        
    }

    async function createGame(){
        const username = window.prompt('Enter your username!');

        if(!username){
            return;
        } 
        const response = await fetch(`https://anagrams.ca/api/connect/create?username=${username}`, {

            method: "POST"
        });

        const data = await response.json();

        if(data['error']){
            return alert(data['error']);
        }
        console.log('Recieved Data from joining...');
        console.log(data)
        navigate(`/connectfour`, {
            state: {
                gameId: data['gameId'],
                username: username
            }
        });

    }

    return (
        <>
            <div className="Title">
                <h1>Dots & Boxes Lobbies</h1>
            </div>
            <button className="createGameButton" onClick={() => console.log('Create Game')}>Create Game!</button>
            <div className="GameList">
                <PrintGames games={games} joinClick={() => console.log('Join Game')} />
            </div>
        </>
    )
}


function PrintGames({ games, joinClick }) {
    return (
        <>
            {games.map((game) => {

                if (game.players.list.length >= 2) {
                    return null;
                }

                return (
                    <div className="game" key={game.game_id}>
                        <div className="game-header">
                            <div className="game-info">

                                <p>
                                    <b>Game ID:</b> {game.game_id}
                                </p>

                                <p>
                                    <b>Players:</b>{" "}
                                    {game.players.list.join(", ")}
                                </p>

                            </div>

                            <button
                                className="join-btn"
                                onClick={() => joinClick(game.game_id)}
                            >
                                Join Game
                            </button>

                        </div>
                    </div>
                );
            })}
        </>
    );
}


function CreateGame({callback}){
    return (
    <>

    <button className="createGameButton"
        onClick={() => callback()}>
    </button>

    </>
        )
}
